/* eslint-disable no-unused-expressions, no-confusing-arrow,
@typescript-eslint/no-unused-expressions */
import React, { useEffect, useState, useRef } from 'react';

// Redux
import { useDispatch, useSelector } from 'react-redux';

// Material
import DrawerRoot from '@material-ui/core/Drawer';
import Badge from '@material-ui/core/Badge';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';
import Zoom from '@material-ui/core/Zoom';

// Icons
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

// Clsx
import clsx from 'clsx';

// Helpers
import { getId, getUserType } from 'helpers/auth';
import { setTotalScroll, getTotalScroll } from 'helpers/drawer';

// Actions
import * as DrawerActions from 'store/ducks/drawer/actions';
import * as CollapseActions from 'store/ducks/collapse/actions';
import { setExternalReports } from 'store/ducks/reports/actions';
import * as SellingTerminalsActions from 'store/ducks/sellingTerminals/actions';

// Types
import { ApplicationState } from 'store';

// Constants
import AUTH from 'constants/auth';
import IMAGES from 'constants/images';
import STORAGE from 'constants/storage';
import PATH from 'constants/basePath';

// Envs
import ENVS from 'constants/enviroments';

// Icons
import { Code, Coin } from 'icons/Shopping_Payment_Finance';
import FerryFillSrc from 'assets/images/icons/DesignSysten2.0/location_transport/Balsa.svg';

// Components
import {
  MenuItem,
  MenuCollapse,
  SupervisorHeader,
  CompanyHeader,
  SchoolHeader,
  SellingTerminalHeader,
} from './components';

import { SystemVersion } from '../SystemVersion';

// Styles
import useStyles from './styles';

interface StateProps {}

interface DispatchProps {}

interface OwnProps {}

type Props = StateProps & DispatchProps & OwnProps;

const Drawer: React.FunctionComponent<Props> = () => {
  const classes = useStyles();
  const userType = getUserType();
  const dispatch = useDispatch();
  const id = getId();
  const CONSORTION_TYPE = 1;

  const [isConsortion, setisConsortion] = useState(false);

  const wrapperListRef = useRef<HTMLDivElement | null>(null);

  const transportOperatorSelected = useSelector(
    (state: ApplicationState) =>
      state.transportOperators.transportOperatorSelected,
  );

  const collapseList = useSelector(
    (state: ApplicationState) => state.collapse.collapseList,
  );

  const drawerOpen = useSelector(
    (state: ApplicationState) => state.drawer.open,
  );

  const externalReports = useSelector(
    (state: ApplicationState) => state.reports.externalReports,
  );

  const sellingTerminal = useSelector(
    (state: ApplicationState) =>
      state.sellingTerminals.sellingTerminalData || null,
  );

  const attendanceUnreadTotal = useSelector((state: ApplicationState) =>
    state.attendance.openedUsers.reduce(
      (total, user) => total + (user.unreadMessages || 0),
      0,
    ),
  );

  const handleDrawer = () => {
    const isOpen = collapseList.filter((collapse) => collapse.open === true);

    if (isOpen.length) {
      localStorage.setItem(STORAGE.DRAWER.ITEM_OPEN, isOpen[0].title);
    }

    if (drawerOpen) {
      const closeAllCollapseList = collapseList.map((collapse) => ({
        ...collapse,
        open: false,
      }));

      dispatch(
        CollapseActions.setToggleCollapse({
          collapseList: closeAllCollapseList,
        }),
      );
    }

    if (!drawerOpen && localStorage.getItem(STORAGE.DRAWER.ITEM_OPEN)) {
      const recoverItemCollapseList = collapseList.map((collapse) =>
        collapse.title === localStorage.getItem(STORAGE.DRAWER.ITEM_OPEN)
          ? { ...collapse, open: true }
          : { ...collapse, open: false },
      );

      dispatch(
        CollapseActions.setToggleCollapse({
          collapseList: recoverItemCollapseList,
        }),
      );
    }

    dispatch(
      DrawerActions.setToggleDrawer({
        open: !drawerOpen,
      }),
    );
  };

  const hasOnlyExternalReports = (userModules: any) => {
    const reportsModules = [
      '37',
      '38',
      '75',
      '39',
      '101',
      '102',
      '103',
      '40',
      '41',
      '42',
      '43',
      '74',
      '90',
      '92',
      '93',
      '104',
      '44',
      '66',
      '98',
      '99',
      '45',
      '73',
      '46',
      '81',
      '71',
      '84',
      '65',
      '83',
      '47',
      '82',
      '48',
      '49',
      '50',
      '51',
      '85',
      '79',
      '80',
      '86',
      '89',
      '95',
      '97',
      '100',
      '112',
      '108',
      '114',
      '115',
      '116',
    ];

    const userReportsModules = userModules.filter((mod: any) =>
      reportsModules.includes(mod),
    );
    return userReportsModules.length === 1 && userReportsModules[0] === '108';
  };

  const buildArrayItems = () => {
    const userHasOnlyExternalReports = hasOnlyExternalReports(
      JSON.parse(
        transportOperatorSelected?.SupervisorOperator?.modules || '[]',
      ),
    );

    if (userHasOnlyExternalReports) {
      return [
        [
          {
            title: '',
            subtitle: 'Relatórios Exclusivos',
            modules: ['108'],
          },
        ].concat(
          externalReports?.length > 0
            ? externalReports
                .map((e: any) => {
                  if (e.additionalId) {
                    if (
                      JSON.parse(
                        transportOperatorSelected?.SupervisorOperator
                          ?.modules || '[]',
                      )?.includes(e.additionalId)
                    ) {
                      return e;
                    }
                    return null;
                  }
                  return e;
                })
                .filter((e: any) => Boolean(e))
                ?.map((item: any) => {
                  const noSpaceTitle = item?.title
                    ? item?.title.replace(/ /g, '')
                    : '';
                  return {
                    title: '',
                    subtitle: item?.title ? item?.title : '',
                    modules: ['108'],
                    pathRoute: `${PATH.EXTERNAL_REPORTS.BASE_URL}/${noSpaceTitle}`,
                  };
                })
            : [],
        ),
      ];
    }

    return [
      [
        {
          title: '',
          subtitle: 'Embarque',
          modules: [],
        },
        {
          title: '',
          subtitle: 'Entradas',
          modules: ['37'],
          pathRoute: PATH.TABLE_ENTRY_REPORT.BASE_URL,
        },
        {
          title: '',
          subtitle: 'Saídas',
          modules: ['121'],
          pathRoute: PATH.TABLE_EXIT_REPORT.BASE_URL,
        },
        {
          title: '',
          subtitle: 'Valor',
          modules: ['38'],
          pathRoute: PATH.CHART_VALUE_REPORT.BASE_URL,
        },
        {
          title: '',
          subtitle: 'Por linha',
          modules: ['75'],
          pathRoute: PATH.SHIPMENT_BY_LINE_REPORT.BASE_URL,
        },
        {
          title: '',
          subtitle: 'Localização',
          modules: ['39'],
          pathRoute: PATH.SHIPMENT_DISTRIBUTION.BASE_URL,
        },
        {
          title: '',
          subtitle: 'Passageiros e Veículos',
          modules: ['101'],
          pathRoute: PATH.PASSENGERS_AND_VEHICLES.BASE_URL,
        },
        {
          title: '',
          subtitle: 'Passageiros e Veículos por viagem',
          modules: ['102'],
          pathRoute: PATH.PASSENGERS_AND_VEHICLES_BY_TRIP.BASE_URL,
        },
        {
          title: '',
          subtitle: 'Passageiros por Terminal',
          modules: ['103'],
          pathRoute: PATH.PASSENGERS_BY_TERMINAL.BASE_URL,
        },
      ],
      [
        {
          title: '',
          subtitle: 'Arrecadação',
          modules: [],
        },
        {
          title: '',
          subtitle: 'Recebimento',
          modules: ['40'],
          pathRoute: PATH.RECEIPTS_REPORT.BASE_URL,
        },
        {
          title: '',
          subtitle: 'Venda a Bordo',
          modules: ['41'],
          pathRoute: PATH.ONBOARD_SALES_REPORT.BASE_URL,
        },
        {
          title: '',
          subtitle: 'Rede de Venda',
          modules: ['42'],
          pathRoute: PATH.COLLECTION_REPORT.BASE_URL,
        },
        {
          title: '',
          subtitle: 'VT e Usuários',
          modules: ['43'],
          pathRoute: PATH.TRANSPORT_VOUCHER_COLLECTION_REPORT.BASE_URL,
        },
        {
          title: '',
          subtitle: 'Requisição Pagamento',
          modules: ['74'],
          pathRoute: PATH.PAYMENT_REQUEST_REPORT.BASE_URL,
        },
        {
          title: '',
          subtitle: 'Consolidação da Arrecadação',
          modules: ['90'],
          pathRoute: PATH.COLLECTION_CONSOLIDATION_REPORT.BASE_URL,
        },
        {
          title: '',
          subtitle: 'Coleta',
          modules: ['92'],
          pathRoute: PATH.TICKET_AVERAGE_REPORT.BASE_URL,
        },
        {
          title: '',
          subtitle: 'Emv',
          modules: ['93'],
          pathRoute: PATH.EMV_REPORT.BASE_URL,
        },
        {
          title: '',
          subtitle: 'Ocorrências Emv',
          modules: ['93'],
          pathRoute: PATH.EMV_REPORT_OCURRENCES.BASE_URL,
        },
        {
          title: '',
          subtitle: 'Consolidado por Escola',
          modules: ['104'],
          pathRoute: PATH.SCHOOL_ORDER_REPORT.BASE_URL,
        },
        {
          title: '',
          subtitle: 'Bilhete eletrônico',
          modules: ['114'],
          pathRoute: PATH.BPE_REPORT.BASE_URL,
        },
        {
          title: '',
          subtitle: 'BPe apuração do ICMS',
          modules: ['115'],
          pathRoute: PATH.BPE_TAX_VERIFICATION_REPORT.BASE_URL,
        },
        {
          title: '',
          subtitle: 'Gratuidades',
          modules: ['116'],
          pathRoute: PATH.GRATUITIES_REPORT.BASE_URL,
        },
      ],
      [
        {
          title: '',
          subtitle: 'Empresas',
          modules: [],
        },
        {
          title: '',
          subtitle: 'Compras',
          modules: ['44'],
          pathRoute: PATH.COMPANY_ACQUISITIONS_REPORT.BASE_URL,
        },
        {
          title: '',
          subtitle: 'Importações',
          modules: ['66'],
          pathRoute: PATH.COMPANY_IMPORTATIONS_REPORT.BASE_URL,
        },
      ],
      [
        {
          title: '',
          subtitle: 'Utilizações',
          modules: [],
        },
        {
          title: '',
          subtitle: 'Créditos por colégio',
          modules: ['98'],
          pathRoute: PATH.CREDITS_BY_COLLEGE.BASE_URL,
        },
        {
          title: '',
          subtitle: 'Estatística de utilização',
          modules: ['99'],
          pathRoute: PATH.USAGE_STATISTICS.BASE_URL,
        },
      ],
      [
        {
          title: '',
          subtitle: 'Usuários',
          modules: [],
        },
        {
          title: '',
          subtitle: 'Saldo',
          modules: ['45'],
          pathRoute: PATH.EMTU_REPORT.BASE_URL,
        },
        {
          title: '',
          subtitle: 'Relatório de Uso Superiores',
          modules: ['73'],
          pathRoute: PATH.REPORT_SUPERIOR_ACCESS.BASE_URL,
        },
      ],
      [
        {
          title: '',
          subtitle: 'Operação',
          modules: [],
        },
        {
          title: '',
          subtitle: 'Demanda por Linha',
          modules: ['46'],
          pathRoute: PATH.LINE_DEMAND_REPORT.BASE_URL,
        },
        {
          title: '',
          subtitle: 'Quantidade por Linha',
          modules: ['81'],
          pathRoute: PATH.LINE_QUANTITY_REPORT.BASE_URL,
        },
        {
          title: '',
          subtitle: 'Demanda por Trecho',
          modules: ['71'],
          pathRoute: PATH.SEGMENT_DEMAND_REPORT.BASE_URL,
        },
        {
          title: '',
          subtitle: 'Quantidade por Trecho',
          modules: ['84'],
          pathRoute: PATH.SEGMENT_QUANTITY_REPORT.BASE_URL,
        },
        {
          title: '',
          subtitle: 'Demanda por Dia',
          modules: ['65'],
          pathRoute: PATH.DAILY_DEMAND_REPORT.BASE_URL,
        },
        {
          title: '',
          subtitle: 'Quantidade por Dia',
          modules: ['83'],
          pathRoute: PATH.DAILY_QUANTITY_REPORT.BASE_URL,
        },
        {
          title: '',
          subtitle: 'Demanda por Carro',
          modules: ['47'],
          pathRoute: PATH.CAR_DEMAND_REPORT.BASE_URL,
        },
        {
          title: '',
          subtitle: 'Quantidade por Carro',
          modules: ['82'],
          pathRoute: PATH.CAR_QUANTITY_REPORT.BASE_URL,
        },
        {
          title: '',
          subtitle: 'Meia Viagem',
          modules: ['48'],
          pathRoute: PATH.HALF_TRIP_DIARY.BASE_URL,
        },
        {
          title: '',
          subtitle: 'Comissão de Operadores',
          modules: ['49'],
          pathRoute: PATH.OPERATOR_COMMISSION_REPORT.BASE_URL,
        },
        {
          title: '',
          subtitle: 'Relatório Passageiros Transportados',
          modules: ['50'],
          pathRoute: PATH.GENERAL_REPORT.BASE_URL,
        },
        {
          title: '',
          subtitle: 'Viagens por Linha',
          modules: ['51'],
          pathRoute: PATH.TRAVEL_BY_LINE_REPORT.BASE_URL,
        },
        {
          title: '',
          subtitle: 'Km Rodados por Dia',
          modules: ['85'],
          pathRoute: PATH.KM_PER_DAY_PER_CAR_REPORT.BASE_URL,
        },
        {
          title: '',
          subtitle: 'Passageiros Transportados',
          modules: ['79'],
          pathRoute: PATH.TRANSPORTED_PASSENGERS_REPORT.BASE_URL,
        },
        {
          title: '',
          subtitle: 'KM Rodados',
          modules: ['80'],
          pathRoute: PATH.KM_DRIVED_REPORT.BASE_URL,
        },
        // {
        //   title: '',
        //   subtitle: 'Utilização de Créditos por Instituição',
        //   modules: ['73'],
        //   pathRoute: PATH.CREDIT_USAGE_BY_INSTITUTION_REPORT.BASE_URL,
        // },
        {
          title: '',
          subtitle: 'Passageiros por Faixa Horária',
          modules: ['86'],
          pathRoute: PATH.PASSENGERS_BY_TIME_FRAME_REPORT.BASE_URL,
        },

        {
          title: '',
          subtitle: 'Resumo de Viagens',
          modules: ['89'],
          pathRoute: PATH.EMPLOYEE_TRIP_RESUME_REPORT.BASE_URL,
        },
        {
          title: '',
          subtitle: 'Passageiros Transportados por Origem',
          modules: ['95'],
          pathRoute: PATH.PASSENGERS_TRANSPORTED_BY_ORIGIN_REPORT.BASE_URL,
        },
        {
          title: '',
          subtitle: 'Passageiros por Faixa Horária/Perfil',
          modules: ['97'],
          pathRoute: PATH.PASSENGERS_BY_TIME_FRAME_BY_PROFILE_REPORT.BASE_URL,
        },
        {
          title: '',
          subtitle: 'Perfil por Faixa Etária',
          modules: ['100'],
          pathRoute: PATH.PROFILE_BY_AGE_GROUP_REPORT.BASE_URL,
        },
        {
          title: '',
          subtitle: 'Estudantes e Mídias',
          modules: ['112'],
          pathRoute: PATH.REPORT_STUDENTS_DEVICE.BASE_URL,
        },
        {
          title: '',
          subtitle: 'Relatório Resumido de Viagens de Motoristas',
          modules: ['89'],
          pathRoute: PATH.EMPLOYEE_TRIP_SAP_RESUME_REPORT.BASE_URL,
        },
      ],
      [
        {
          title: '',
          subtitle: 'Relatórios Assíncronos',
          modules: [''],
          pathRoute: PATH.ASYNCHRONOUS_REPORTS.BASE_URL,
        },
      ],
      [
        {
          title: '',
          subtitle: 'Relatórios Exclusivos',
          modules: ['108'],
        },
      ].concat(
        externalReports?.length > 0
          ? externalReports
              .map((e: any) => {
                if (e.additionalId) {
                  if (
                    JSON.parse(
                      transportOperatorSelected?.SupervisorOperator?.modules ||
                        '[]',
                    )?.includes(e.additionalId)
                  ) {
                    return e;
                  }
                  return null;
                }
                return e;
              })
              .filter((e: any) => Boolean(e))
              ?.map((item: any) => {
                const noSpaceTitle = item?.title
                  ? item?.title.replace(/ /g, '')
                  : '';
                return {
                  title: '',
                  subtitle: item?.title ? item?.title : '',
                  modules: ['108'],
                  pathRoute: `${PATH.EXTERNAL_REPORTS.BASE_URL}/${noSpaceTitle}`,
                };
              })
          : [],
      ),
    ];
  };

  const handleDrawerScroll = () => {
    setTotalScroll(wrapperListRef.current?.scrollTop!);
  };

  useEffect(() => {
    wrapperListRef.current?.addEventListener('scroll', handleDrawerScroll);

    return () => {
      // eslint-disable-next-line
      wrapperListRef.current?.removeEventListener('scroll', handleDrawerScroll);
    };
  }, []);

  useEffect(() => {
    const totalScroll = parseInt(getTotalScroll()!, 10);

    wrapperListRef.current!.scrollTo({
      behavior: 'smooth',
      top: totalScroll,
    });
  }, []);

  useEffect(() => {
    setisConsortion(transportOperatorSelected.type === CONSORTION_TYPE);
  }, []);

  useEffect(() => {
    const fetchText = async () => {
      try {
        if (ENVS.EXTERNAL_REPORTS) {
          const response = await fetch(
            ENVS.REACT_APP_NO_CACHE_EXTERNAL_REPORT
              ? `${ENVS.EXTERNAL_REPORTS}?nocache=${Date.now()}`
              : ENVS.EXTERNAL_REPORTS,
          );
          if (!response.ok) {
            //do nothing
          }

          const text = await response.text();

          if (text) {
            const tempExternalReports = JSON.parse(text);
            dispatch(
              setExternalReports({ externalReports: tempExternalReports }),
            );
          }
        }
      } catch (error) {
        //do nothing
      }
    };

    fetchText();
  }, [ENVS.EXTERNAL_REPORTS]);

  useEffect(() => {
    if (id && userType === AUTH.TYPES.TERMINAL.type) {
      dispatch(
        SellingTerminalsActions.getSellingTerminalRequest({
          withoutTransportOperatorId: true,
          id,
        }),
      );
    }
  }, [dispatch, id, userType]);

  return (
    <DrawerRoot
      className={clsx(classes.drawer, {
        [classes.drawerOpen]: drawerOpen,
        [classes.drawerClose]: !drawerOpen,
      })}
      variant='permanent'
      classes={{
        paper: clsx(classes.drawerPaper, {
          [classes.drawerOpen]: drawerOpen,
          [classes.drawerClose]: !drawerOpen,
        }),
      }}>
      <div
        className={clsx(classes.colLeft, classes.toolbar, {
          [classes.colLeftCloseDrawer]: !drawerOpen,
        })}>
        <div className={classes.wrapperLogo}>
          <img
            alt='logo-onboard'
            src={IMAGES.LOGOS.LOGO_ONBOARD_MOBILITY}
            className={classes.bdosLogo}
          />
          <div className={clsx({ [classes.shadow]: !drawerOpen })} />
        </div>
      </div>
      <div className={classes.toolbar} />

      <div
        className={clsx(classes.wrapper, {
          [classes.removeOverflow]: !drawerOpen,
        })}
        ref={wrapperListRef}>
        {userType === AUTH.TYPES.COMPANY.type && <CompanyHeader />}
        {userType === AUTH.TYPES.SUPERVISOR.type && <SupervisorHeader />}
        {userType === AUTH.TYPES.TERMINAL.type && <SellingTerminalHeader />}
        {userType === AUTH.TYPES.SCHOOL.type && <SchoolHeader />}
        <Divider
          classes={{
            root: classes.divider,
          }}
        />
        <List className={classes.list}>
          {/* ATTENDANCE */}
          <MenuCollapse
            isConsortion={isConsortion}
            types={['SUPERVISOR', 'ATTENDANT']}
            modules={['53', '54', '55']}
            title='Atendimento'
            open={
              collapseList.filter((item) => item.title === 'Atendimento')[0]
                .open
            }
            icon={
              <Badge badgeContent={attendanceUnreadTotal} color='error'>
                <img
                  alt='Atendimento'
                  src={IMAGES.ICONS.ATTENDANCE}
                  className={clsx(classes.drawerIcon, {
                    [classes.drawerIconMargin]: !drawerOpen,
                  })}
                />
              </Badge>
            }
            items={[
              {
                title: '',
                subtitle: 'Conversas',
                pathRoute: PATH.ATTENDANCE.BASE_URL,
                modules: ['53'],
                badge: attendanceUnreadTotal,
              },
              {
                title: '',
                subtitle: 'Configurações',
                pathRoute: PATH.ATTENDANCE.CONFIGURATIONS,
                modules: ['54'],
              },
              {
                title: '',
                subtitle: 'Relatórios',
                modules: ['55'],
                pathRoute: PATH.ATTENDANCE.REPORTS,
              },
            ]}
          />

          {/* CLIENTES */}
          <MenuCollapse
            isConsortion={isConsortion}
            types={['SUPERVISOR']}
            modules={['0', '1', '2']}
            title='Clientes'
            open={
              collapseList.filter((item) => item.title === 'Clientes')[0].open
            }
            icon={
              <img
                alt='Clientes'
                src={IMAGES.ICONS.PERSON}
                className={clsx(classes.drawerIcon, {
                  [classes.drawerIconMargin]: !drawerOpen,
                })}
              />
            }
            items={[
              {
                modules: ['0'],
                title: '',
                subtitle: 'Passageiros',
                pathRoute: PATH.PASSENGER.BASE_URL,
              },
              {
                modules: ['1'],
                title: '',
                subtitle: 'Empresas',
                pathRoute: PATH.COMPANIES.BASE_URL,
              },
              {
                modules: ['2'],
                title: '',
                subtitle: 'Instituições de Ensino',
                pathRoute: PATH.SCHOOLS.BASE_URL,
              },
            ]}
          />

          <MenuCollapse
            isConsortion={isConsortion}
            types={['SUPERVISOR']}
            modules={['3', '4', '5']}
            title='Validações'
            open={
              collapseList.filter((item) => item.title === 'Validações')[0].open
            }
            icon={
              <img
                style={{ width: 20, height: 19 }}
                alt='Validações'
                src={IMAGES.ICONS.CHECK_CIRCLE_OUTLINE}
                className={clsx(classes.drawerIcon, {
                  [classes.drawerIconMargin]: !drawerOpen,
                })}
              />
            }
            items={[
              {
                modules: ['3'],
                title: '',
                subtitle: 'Validação Cadastral',
                pathRoute: PATH.REGISTRATION_VALIDATION.BASE_URL,
              },
              {
                modules: ['4'],
                title: '',
                subtitle: 'Reconhecimento Facial',
                pathRoute: PATH.FACIAL_RECOGNITION.BASE_URL,
              },
              {
                modules: ['5'],
                title: '',
                subtitle: 'Liberação de Dispositivo',
                pathRoute: PATH.DEVICE_RELEASE.BASE_URL,
              },
              {
                modules: ['5'],
                title: '',
                subtitle: 'Inspeção de Embarques',
                pathRoute: PATH.BOARDING_INSPECTION.BASE_URL,
              },
            ]}
          />
          <MenuCollapse
            isConsortion={isConsortion}
            types={['SUPERVISOR']}
            modules={['8']}
            title='Frota'
            open={collapseList.filter((item) => item.title === 'Frota')[0].open}
            icon={
              <img
                alt='Frota'
                src={FerryFillSrc}
                className={clsx(classes.drawerIcon, {
                  [classes.drawerIconMargin]: !drawerOpen,
                })}
              />
            }
            items={[
              {
                modules: ['8'],
                title: '',
                subtitle: 'Ônibus',
                pathRoute: PATH.FLEET.BASE_URL,
              },
              {
                modules: ['4'],
                title: '',
                subtitle: 'Embarcações',
                pathRoute: PATH.VESSELS.BASE_URL,
              },
              {
                modules: ['8'],
                title: '',
                subtitle: 'Plantas',
                pathRoute: PATH.PLANTAS.BASE_URL,
              },
            ]}
          />

          <MenuCollapse
            isConsortion={isConsortion}
            types={['SUPERVISOR']}
            modules={['10', '11', '12', '119']}
            title='Equipe'
            open={
              collapseList.filter((item) => item.title === 'Equipe')[0].open
            }
            icon={
              <img
                alt='Equipe'
                src={IMAGES.ICONS.TEAM}
                className={clsx(classes.drawerIcon, {
                  [classes.drawerIconMargin]: !drawerOpen,
                })}
              />
            }
            items={[
              {
                modules: ['10'],
                title: '',
                subtitle: 'Motoristas',
                pathRoute: PATH.DRIVERS.BASE_URL,
              },
              {
                modules: ['11'],
                title: '',
                subtitle: 'Cobradores',
                pathRoute: PATH.TICKET_COLLECTORS.BASE_URL,
              },
              {
                modules: ['12'],
                title: '',
                subtitle: 'Encarregados',
                pathRoute: PATH.IN_CHARGE.BASE_URL,
              },
              {
                modules: ['119'],
                title: '',
                subtitle: 'Gestão de máquinas',
                pathRoute: PATH.MACHINE_MANAGEMENT.BASE_URL,
              },
            ]}
          />

          <MenuCollapse
            isConsortion={isConsortion}
            moduleConsortionHasAutorization
            types={['SUPERVISOR']}
            modules={['13', '14', '15', '16', '17', '18']}
            title='Bilhetagem'
            open={
              collapseList.filter((item) => item.title === 'Bilhetagem')[0].open
            }
            icon={
              <img
                alt='Bilhetagem'
                src={IMAGES.ICONS.TICKETING}
                className={clsx(classes.drawerIcon, {
                  [classes.drawerIconMargin]: !drawerOpen,
                })}
              />
            }
            items={[
              {
                title: '',
                modules: ['13'],
                subtitle: 'DBDs',
                pathRoute: PATH.DBDS.BASE_URL,
              },
              // temporarily hidden
              // {
              //   title: '',
              //   modules: ['LOT'],
              //   subtitle: 'Lote de Crédito',
              //   pathRoute: PATH.LOTS.BASE_URL,
              // },
              {
                modules: ['14'],
                title: '',
                subtitle: 'Cartões de Transporte',
                pathRoute: PATH.TRANSPORT_CARDS.BASE_URL,
              },
              {
                title: '',
                modules: ['15'],
                subtitle: 'Perfis',
                pathRoute: PATH.PROFILES.BASE_URL,
              },
              {
                title: '',
                subtitle: 'Tarifas',
                modules: ['16'],
                pathRoute: PATH.FARES.BASE_URL,
              },
              {
                title: '',
                subtitle: 'Alterações por período',
                modules: ['16'],
                pathRoute: PATH.CHANGES_BY_PERIOD.BASE_URL,
              },
              {
                title: '',
                subtitle: 'Taxas de Embarque',
                modules: ['16'],
                pathRoute: PATH.BOARDING_FARES.BASE_URL,
              },
              {
                title: '',
                subtitle: 'Produtos',
                modules: ['61'],
                pathRoute: PATH.PRODUCTS.BASE_URL,
              },
              {
                modules: ['17'],
                title: '',
                subtitle: 'Políticas Tarifárias',
                pathRoute: PATH.BENEFITS.BASE_URL,
              },
              {
                modules: ['70'],
                title: '',
                subtitle: 'Catracas',
                pathRoute: PATH.TURNSTILES.BASE_URL,
              },
              {
                modules: ['18'],
                title: '',
                subtitle: 'Integrações',
                pathRoute: PATH.LINE_MATRIX.BASE_URL,
                moduleConsortionHasAutorization: true,
              },
              {
                modules: ['19', '24', '91'],
                title: '',
                subtitle: 'Gestão de Estações',
                pathRoute: PATH.METRO_STATION_MANAGEMENT.BASE_URL,
              },
              {
                modules: ['120'],
                title: '',
                subtitle: 'Materiais Impressos',
                pathRoute: PATH.PRINT_MODEL.BASE_URL,
              },
            ]}
          />

          <MenuCollapse
            isConsortion={isConsortion}
            types={['SUPERVISOR']}
            modules={['19']}
            title='Operação'
            open={
              collapseList.filter((item) => item.title === 'Operação')[0].open
            }
            icon={
              <img
                alt='Operação'
                src={IMAGES.ICONS.OPERATION}
                className={clsx(classes.drawerIcon, {
                  [classes.drawerIconMargin]: !drawerOpen,
                })}
              />
            }
            items={[
              {
                title: '',
                subtitle: 'Linhas',
                modules: ['19'],
                pathRoute: PATH.LINES.BASE_URL,
              },
              {
                title: '',
                subtitle: 'Paradas',
                modules: ['21'],
                pathRoute: PATH.STOPS.BASE_URL,
              },
              {
                title: '',
                subtitle: 'Seções',
                modules: ['22'],
                pathRoute: PATH.SECTIONS.BASE_URL,
              },
              {
                title: '',
                subtitle: 'Garagens',
                modules: ['23'],
                pathRoute: PATH.GARAGE.BASE_URL,
              },
              {
                title: '',
                subtitle: 'Terminais',
                modules: ['24'],
                pathRoute: PATH.TERMINAL_MANAGEMENT.BASE_URL,
              },
              {
                title: '',
                subtitle: 'Cercas',
                modules: ['76'],
                pathRoute: PATH.INTEGRATION_FENCE.BASE_URL,
              },
              // {
              //   title: '',
              //   subtitle: 'Bloqueios',
              //   modules: ['24'],
              //   pathRoute: PATH.TERMINAL_BLOCKS.BASE_URL,
              // },
              {
                title: '',
                subtitle: 'Pedágios',
                modules: ['25'],
                pathRoute: PATH.TOLLS.BASE_URL,
              },
            ]}
          />
          <MenuCollapse
            isConsortion={isConsortion}
            types={['SUPERVISOR']}
            modules={['68']}
            title='Conectividade'
            open={
              collapseList.filter((item) => item.title === 'Conectividade')[0]
                .open
            }
            icon={
              <img
                alt='Conectividade'
                src={IMAGES.ICONS.CONECTIVITY}
                className={clsx(classes.drawerIcon, {
                  [classes.drawerIconMargin]: !drawerOpen,
                })}
              />
            }
            items={[
              {
                title: '',
                subtitle: 'Planos de Dados',
                pathRoute: PATH.DATA_PLAN_CONNECTIVITY.BASE_URL,
              },
              // This feature now renders at the "Planos de Dados" route above
              // (see PATH.DATA_PLAN_CONNECTIVITY in App.tsx) instead of its own
              // drawer entry. To revert, uncomment this and swap the component
              // back in App.tsx.
              // {
              //   title: '',
              //   subtitle: 'Planos de Dados',
              //   pathRoute: PATH.CONNECTIVITY_CHIPS.BASE_URL,
              // },
              {
                title: '',
                subtitle: 'Cobertura de Conexão',
                pathRoute: PATH.CONECTION_COVER_CONNECTIVITY.BASE_URL,
              },
            ]}
          />

          <MenuCollapse
            isConsortion={isConsortion}
            types={['SUPERVISOR']}
            modules={['20']}
            title='Planejamento'
            open={
              collapseList.filter((item) => item.title === 'Planejamento')[0]
                .open
            }
            icon={
              <img
                alt='Planejamento'
                src={IMAGES.ICONS.TABLE}
                className={clsx(classes.drawerIcon, {
                  [classes.drawerIconMargin]: !drawerOpen,
                })}
              />
            }
            items={[
              {
                title: '',
                modules: ['20'],
                subtitle: 'Itinerários',
                pathRoute: PATH.ITINERARIES.BASE_URL,
              },
              {
                title: '',
                modules: ['20'],
                subtitle: 'Matriz de Escalas',
                pathRoute: PATH.SCHEDULES_MATRIX.BASE_URL,
              },
              {
                title: '',
                modules: ['20'],
                subtitle: 'Escalas',
                pathRoute: PATH.SCHEDULES.BASE_URL,
              },
            ]}
          />
          <MenuCollapse
            isConsortion={isConsortion}
            types={['SUPERVISOR']}
            modules={['28', '119']}
            title='Rede de Vendas'
            open={
              collapseList.filter((item) => item.title === 'Rede de Vendas')[0]
                .open
            }
            icon={
              <img
                alt='sales network'
                src={IMAGES.ICONS.SALES_NETWORK}
                className={clsx(classes.drawerIcon, {
                  [classes.drawerIconMargin]: !drawerOpen,
                })}
              />
            }
            items={[
              {
                title: '',
                subtitle: 'Gestão das redes',
                pathRoute: PATH.SALES_NETWORK.BASE_URL,
                modules: ['28'],
              },
              {
                title: '',
                subtitle: 'Gestão de máquinas',
                pathRoute: PATH.SALES_NETWORK_MACHINE_MANAGEMENT.BASE_URL,
                modules: ['119'],
              },
            ]}
          />

          <MenuCollapse
            isConsortion={isConsortion}
            types={['SUPERVISOR']}
            modules={['28', '29', '30', '124']}
            title='Arrecadação'
            open={
              collapseList.filter((item) => item.title === 'Arrecadação')[0]
                .open
            }
            icon={
              <img
                alt='Arrecadação'
                src={IMAGES.ICONS.COLLECTION}
                className={clsx(classes.drawerIcon, {
                  [classes.drawerIconMargin]: !drawerOpen,
                })}
              />
            }
            items={[
              {
                title: '',
                modules: ['28'],
                subtitle: 'Redes de Venda',
                pathRoute: PATH.SELLING_TERMINALS.BASE_URL,
              },
              {
                title: '',
                modules: [],
                subtitle: 'Recebimentos',
                pathRoute: PATH.RECEIVABLES.BASE_URL,
              },
              {
                title: '',
                subtitle: 'Vendas a Bordo',
                modules: ['29'],
                pathRoute: PATH.ONBOARD_SALES.BASE_URL,
              },
              {
                title: '',
                modules: [],
                subtitle: 'Venda de Passagens',
                externalPathRoute: ENVS.TICKET_SALES.TICKET_SALES_URL,
              },
              {
                title: '',
                subtitle: 'Empresas',
                modules: ['30'],
                pathRoute: PATH.TRANSPORT_VOUCHER.BASE_URL,
              },
              {
                title: '',
                subtitle: 'Instituição',
                modules: ['2'],
                pathRoute: PATH.COLLECTION_INSTITUITION.BASE_URL,
              },
              {
                title: '',
                subtitle: 'Passageiros',
                modules: ['0'],
                pathRoute: PATH.COLLECTION_PASSENGER.BASE_URL,
              },
              {
                title: '',
                subtitle: 'Notas Fiscais',
                modules: ['94'],
                pathRoute: PATH.INVOICES_MODULE.BASE_URL,
              },
              {
                title: '',
                subtitle: 'Recargas automáticas',
                modules: ['124'],
                pathRoute: PATH.AUTOMATIC_CHARGE.BASE_URL,
              },
            ]}
          />

          <MenuCollapse
            isConsortion={isConsortion}
            types={['SUPERVISOR']}
            modules={['27']}
            title='Monitoramento'
            open={
              collapseList.filter((item) => item.title === 'Monitoramento')[0]
                .open
            }
            icon={
              <img
                alt='Monitoramento'
                src={IMAGES.ICONS.MONITORING}
                className={clsx(classes.drawerIcon, {
                  [classes.drawerIconMargin]: !drawerOpen,
                })}
              />
            }
            items={[
              {
                title: '',
                subtitle: 'Ao Vivo',
                pathRoute: PATH.LIVE_MONITORING.BASE_URL,
              },
              {
                title: '',
                subtitle: 'Viagens',
                pathRoute: PATH.TRIP_MONITORING.BASE_URL,
              },
              {
                title: '',
                subtitle: 'Painel de Mensagem Variável ',
                pathRoute: PATH.VARIABLE_MESSAGE_BOARD.BASE_URL,
              },
              {
                title: '',
                subtitle: 'Registro de KM',
                pathRoute: PATH.KM_RECORD.BASE_URL,
              },
              {
                title: '',
                subtitle: 'Fiscalização',
                pathRoute: PATH.FISCALIZATION.BASE_URL,
              },
            ]}
          />

          <MenuCollapse
            isConsortion={isConsortion}
            moduleConsortionHasAutorization
            moduleConsortionHasAllAutorization
            types={['SUPERVISOR']}
            modules={[
              '37',
              '38',
              '75',
              '39',
              '101',
              '102',
              '103',
              '40',
              '41',
              '42',
              '43',
              '74',
              '90',
              '92',
              '93',
              '104',
              '44',
              '66',
              '98',
              '99',
              '45',
              '73',
              '46',
              '81',
              '71',
              '84',
              '65',
              '83',
              '47',
              '82',
              '48',
              '49',
              '50',
              '51',
              '85',
              '79',
              '80',
              '86',
              '89',
              '95',
              '97',
              '100',
              '112',
              '108',
              '114',
              '115',
              '116',
            ]}
            title='Relatórios'
            open={
              collapseList.filter((item) => item.title === 'Relatórios')[0].open
            }
            icon={
              <img
                alt='Relatórios'
                src={IMAGES.ICONS.REPORTS}
                className={clsx(classes.drawerIcon, {
                  [classes.drawerIconMargin]: !drawerOpen,
                })}
              />
            }
            arrayItems={buildArrayItems()}
          />

          <MenuCollapse
            isConsortion={isConsortion}
            types={['SUPERVISOR']}
            modules={['27']}
            title='Central de Integridade'
            open={
              collapseList.filter(
                (item) => item.title === 'Central de Integridade',
              )[0].open
            }
            icon={
              <img
                alt='Central de Integridade'
                src={IMAGES.ICONS.INTEGRITY_CENTER}
                className={clsx(classes.drawerIcon, {
                  [classes.drawerIconMargin]: !drawerOpen,
                })}
              />
            }
            items={[
              {
                title: '',
                subtitle: 'Irregularidades',
                pathRoute: PATH.ANOMALIES.BASE_URL,
              },
            ]}
          />

          {/* Relacionamento */}
          <MenuCollapse
            isConsortion={isConsortion}
            types={['SUPERVISOR']}
            modules={['6', '7']}
            title='Relacionamento'
            open={
              collapseList.filter((item) => item.title === 'Relacionamento')[0]
                .open
            }
            icon={
              <img
                alt='Relacionamento'
                src={IMAGES.ICONS.PLANNING}
                className={clsx(classes.drawerIcon, {
                  [classes.drawerIconMargin]: !drawerOpen,
                })}
              />
            }
            items={[
              {
                title: '',
                modules: ['6'],
                subtitle: 'Notificações',
                pathRoute: PATH.NOTIFICATIONS.BASE_URL,
              },
              {
                title: '',
                modules: ['7'],
                subtitle: 'Segmentações',
                pathRoute: PATH.SEGMENTATIONS.BASE_URL,
              },
            ]}
          />

          <MenuCollapse
            isConsortion={isConsortion}
            types={['SUPERVISOR']}
            modules={['32']}
            title='Ajustes'
            open={
              collapseList.filter((item) => item.title === 'Ajustes')[0].open
            }
            icon={
              <img
                alt='Ajustes'
                src={IMAGES.ICONS.ADJUSTMENT}
                className={clsx(classes.drawerIcon, {
                  [classes.drawerIconMargin]: !drawerOpen,
                })}
              />
            }
            items={[
              {
                title: '',
                subtitle: 'Reportar Ajustes',
                pathRoute: PATH.BUG_REPORTS.BASE_URL,
              },
            ]}
          />

          <MenuItem
            isConsortion={isConsortion}
            title='Faturas'
            types={['SUPERVISOR']}
            modules={['33']}
            pathRoute={PATH.INVOICES.BASE_URL}
            icon={
              <img
                alt='Faturas'
                src={IMAGES.ICONS.FINANCIAL}
                className={clsx(classes.drawerIcon, {
                  [classes.drawerIconMargin]: !drawerOpen,
                })}
              />
            }
          />

          {/* COMPANIES */}
          <MenuItem
            isConsortion={isConsortion}
            title='Colaboradores'
            types={['COMPANY']}
            modules={[]}
            pathRoute={PATH.COMPANY_COLLABORATORS.BASE_URL}
            icon={
              <img
                alt='Colaboradores'
                src={IMAGES.ICONS.COMPANY_COLLABORATORS}
                className={clsx(classes.drawerIcon, {
                  [classes.drawerIconMargin]: !drawerOpen,
                })}
              />
            }
          />

          {/* <MenuItem
            isConsortion={isConsortion}
            title='Pedidos'
            types={['COMPANY']}
            modules={[]}
            pathRoute={PATH.COMPANY_ORDERS.BASE_URL}
            icon={
              <img
                alt='Pedidos'
                src={IMAGES.ICONS.TICKETING}
                className={clsx(classes.drawerIcon, {
                  [classes.drawerIconMargin]: !drawerOpen,
                })}
              />
            }
          /> */}

          {/* <MenuItem
            isConsortion={isConsortion}
            title='Histórico'
            types={['COMPANY']}
            modules={[]}
            pathRoute={PATH.COMPANY_ORDERS_HISTORY.BASE_URL}
            icon={
              <img
                alt='Histórico'
                src={IMAGES.ICONS.TICKETING}
                className={clsx(classes.drawerIcon, {
                  [classes.drawerIconMargin]: !drawerOpen,
                })}
              />
            }
          /> */}

          <MenuCollapse
            isConsortion={isConsortion}
            isCompany={userType === AUTH.TYPES.COMPANY.type}
            types={['COMPANY']}
            modules={[]}
            title='Benefícios'
            open={
              collapseList.filter((item) => item.title === 'Benefícios')[0].open
            }
            icon={
              <img
                alt='Benefícios'
                src={IMAGES.ICONS.COMPANY_BENEFITS}
                className={clsx(classes.drawerIcon, {
                  [classes.drawerIconMargin]: !drawerOpen,
                })}
              />
            }
            items={[
              {
                title: '',
                subtitle: 'Pedidos',
                pathRoute: PATH.COMPANY_ORDERS.BASE_URL,
              },
              {
                title: '',
                subtitle: 'Histórico',
                pathRoute: PATH.COMPANY_ORDERS_HISTORY.BASE_URL,
              },
              // {
              //   title: '',
              //   subtitle: 'Faturas',
              //   pathRoute: PATH.COMPANY_INVOICES.BASE_URL,
              // },
            ]}
          />

          <MenuCollapse
            isConsortion={isConsortion}
            isCompany={userType === AUTH.TYPES.COMPANY.type}
            types={['COMPANY']}
            modules={[]}
            title='Relatórios'
            open={
              collapseList.filter((item) => item.title === 'Relatórios')[0].open
            }
            icon={
              <img
                alt='Relatórios'
                src={IMAGES.ICONS.REPORTS}
                className={clsx(classes.drawerIcon, {
                  [classes.drawerIconMargin]: !drawerOpen,
                })}
              />
            }
            arrayItems={[
              [
                {
                  title: '',
                  subtitle: 'Relatórios Assíncronos',
                  pathRoute: PATH.COMPANY_ASYNCHRONOUS_REPORTS.BASE_URL,
                },
              ],
            ]}
          />

          {/* SCHOOLS */}

          <MenuItem
            isConsortion={isConsortion}
            title='Estudantes'
            types={['SCHOOL']}
            modules={[]}
            pathRoute={PATH.TEACHING_INSTITUTION_STUDENTS.BASE_URL}
            icon={
              <img
                alt='Estudantes'
                src={IMAGES.ICONS.TEAM}
                className={clsx(classes.drawerIcon, {
                  [classes.drawerIconMargin]: !drawerOpen,
                })}
              />
            }
          />

          <MenuItem
            isConsortion={isConsortion}
            title='Pedidos'
            types={['SCHOOL']}
            modules={[]}
            pathRoute={PATH.TEACHING_INSTITUTION_ORDERS.BASE_URL}
            icon={
              <img
                alt='Pedidos'
                src={IMAGES.ICONS.TICKETING}
                className={clsx(classes.drawerIcon, {
                  [classes.drawerIconMargin]: !drawerOpen,
                })}
              />
            }
          />

          <MenuItem
            isConsortion={isConsortion}
            title='Histórico'
            types={['SCHOOL']}
            modules={[]}
            pathRoute={PATH.TEACHING_INSTITUTION_ORDERS_HISTORY.BASE_URL}
            icon={
              <img
                alt='Histórico'
                src={IMAGES.ICONS.TICKETING}
                className={clsx(classes.drawerIcon, {
                  [classes.drawerIconMargin]: !drawerOpen,
                })}
              />
            }
          />

          {/* SELLING TERMINALS */}
          <MenuItem
            isConsortion={isConsortion}
            title='Pontos de Venda'
            types={['TERMINAL']}
            modules={[]}
            pathRoute={PATH.SELLING_POINTS.BASE_URL}
            icon={
              <img
                alt='Arrecadação'
                src={IMAGES.ICONS.COLLECTION}
                className={clsx(classes.drawerIcon, {
                  [classes.drawerIconMargin]: !drawerOpen,
                })}
              />
            }
          />
          <MenuItem
            isConsortion={isConsortion}
            title='Arrecadação'
            types={['TERMINAL']}
            modules={[]}
            pathRoute={PATH.SELLING_TERMINAL_DETAILS.BASE_URL}
            icon={<Coin fill='#fff' />}
          />
          {sellingTerminal.allowTokenPaid && (
            <MenuItem
              isConsortion={isConsortion}
              title='Integração por API'
              types={['TERMINAL']}
              modules={[]}
              pathRoute={PATH.API_INTEGRATION.BASE_URL}
              icon={<Code fill='#fff' />}
            />
          )}
        </List>
      </div>
      <div
        className={clsx(classes.collapse, {
          [classes.collpaseSmall]: !drawerOpen,
        })}>
        <Divider
          classes={{
            root: classes.footerDivider,
          }}
        />
        <Grid
          container
          spacing={2}
          justifyContent={drawerOpen ? 'space-between' : 'flex-end'}
          alignItems='center'>
          {drawerOpen && (
            <Grid item>
              <SystemVersion />
            </Grid>
          )}
          <Tooltip
            title={drawerOpen ? 'Fechar menu' : 'Abrir menu'}
            placement='right'
            arrow
            interactive
            TransitionComponent={Zoom}>
            <IconButton onClick={handleDrawer}>
              {drawerOpen ? (
                <ChevronLeftIcon
                  fontSize='large'
                  className={classes.iconCollapse}
                />
              ) : (
                <ChevronRightIcon
                  fontSize='large'
                  className={classes.iconCollapse}
                />
              )}
            </IconButton>
          </Tooltip>
        </Grid>
      </div>
    </DrawerRoot>
  );
};

export default Drawer;
